import SlideHeading from './SlideHeading';
import SlideOptions, { type SlideOption } from './SlideOptions';

interface SlideProps {
  dataKey?: string;
  heading: string;
  options?: SlideOption[];
  titleRef?: any;
}

export default function Slide({
  dataKey,
  heading,
  options,
  titleRef,
}: SlideProps) {
  return (
    <>
      <SlideHeading heading={heading} titleRef={titleRef} />
      {options ? (
        <SlideOptions dataKey={dataKey ?? ''} options={options} />
      ) : null}
    </>
  );
}
